<script>
  // At-a-glance schedule cell: a seven-letter weekday strip (lit = active) over a
  // muted time/date line. Specific-date schedules swap the strip for a calendar
  // icon + date count. A schedule that can never run renders as a warning.
  // `value` is the server's display-ready cell (AdminSite::ScheduleCell) or null.
  import Icon from '../../ui/icon.svelte'

  let { value } = $props()
</script>

{#if !value}
  <span class="text-base-content/40">—</span>
{:else}
  <div class="flex flex-col gap-1 py-0.5">
    {#if value.specific_dates}
      <span class="inline-flex items-center gap-1.5 text-sm whitespace-nowrap {value.never_runs ? 'text-warning' : ''}">
        <Icon name="calendar" size="sm" class={value.never_runs ? 'text-warning' : 'text-primary'} />
        {value.dates_label}
      </span>
    {:else if value.never_runs}
      <span class="inline-flex items-center gap-1.5 text-sm text-warning whitespace-nowrap">
        <Icon name="warning" size="sm" />
        No days
      </span>
    {:else}
      <div class="flex gap-0.5">
        {#each value.days as day (day.key)}
          <span
            class="h-4 w-4 rounded-full text-center text-[9px] font-semibold leading-4 {day.active
              ? 'bg-primary/15 text-primary'
              : 'text-base-content/30'}">{day.letter}</span>
        {/each}
      </div>
    {/if}
    <span class="text-xs text-base-content/60 whitespace-nowrap">{value.detail}</span>
  </div>
{/if}
